import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import PaymentLinkTable from "../../payment-link-system/PaymentLinkTable";
import {
  convertThenFormat1,
  convertTo12HourFormat,
} from "../../common-data/Converts";
import Loader from "../../ui/Loader";
import PayroleProcessForm from "./PayroleProcessForm";

const NewPayroleProcess = ({ selectedIds, setSelectedIds, userInfoData }) => {
  const { inhouseUsers, loading, error } = useSelector(
    (state) => state.dropdown
  );

  const [staffData, setStaffData] = useState([]);
  const [showPayrollForm, setShowPayrollForm] = useState(false);

  const allSelected =
    selectedIds.length === staffData.length && staffData.length > 0;

  const handleSelectAll = () => {
    if (allSelected) {
      setSelectedIds([]);
    } else {
      setSelectedIds(staffData.map((e) => e.user_id));
    }
  };

  const handleSelectRow = (id) => {
    setSelectedIds((prev) =>
      prev.includes(id) ? prev.filter((i) => i !== id) : [...prev, id]
    );
  };

  useEffect(() => {
    if (!loading && !error && inhouseUsers?.length > 0) {
      setStaffData(inhouseUsers.map((user) => user?.info));
    } else {
      setStaffData([]);
    }
  }, [loading, error, inhouseUsers]);

  const columns = [
    {
      dataField: "user_id",
      text: (
        <input
          type="checkbox"
          className="pp-checkbox"
          checked={allSelected}
          onChange={handleSelectAll}
          aria-label="Select all employees"
        />
      ),
      formatter: (_, row) => (
        <input
          type="checkbox"
          className="pp-checkbox"
          checked={selectedIds.includes(row?.user_id)}
          onChange={() => handleSelectRow(row?.user_id)}
          aria-label={`Select ${row?.name}`}
        />
      ),
    },
    {
      dataField: "name",
      text: "Employee",
      formatter: (_, row) => (
        <div>
          <div className="pp-employee-name">{row?.name || "NA"}</div>
        </div>
      ),
    },
    {
      dataField: "role",
      text: "Role",
      formatter: (_, row) => (
        <span className="tb-data">{row.account_type?.replace(/_/g, " ")}</span>
      ),
    },
    {
      dataField: "gym_id",
      text: "Gym Name",
      formatter: (_, row) => (
        <div>
          <div className="tb-data">{row?.gym_name || "NA"}</div>
        </div>
      ),
    },
    {
      dataField: "netSalary",
      text: "Monthly Salary",
      formatter: (_, row) => (
        <span className="tb-data">
          ₹{convertThenFormat1(row?.monthly_salary || 0)}
        </span>
      ),
    },
    {
      dataField: "morning_shift",
      text: "Morning Shift",
      formatter: (_, row) => {
        const morningShift = row.shift_details?.find(
          (shift) => shift.shift_name?.toLowerCase() === "morning"
        );

        return (
          <span className="tb-data">
            {morningShift
              ? `${convertTo12HourFormat(
                  morningShift?.start_time
                )} - ${convertTo12HourFormat(morningShift?.end_time)}`
              : "-"}
          </span>
        );
      },
    },
    {
      dataField: "evening_shift",
      text: "Evening Shift",
      formatter: (_, row) => {
        const eveningShift = row.shift_details?.find(
          (shift) => shift.shift_name?.toLowerCase() === "evening"
        );

        return (
          <span className="tb-data">
            {eveningShift
              ? `${convertTo12HourFormat(
                  eveningShift?.start_time
                )} - ${convertTo12HourFormat(eveningShift?.end_time)}`
              : "-"}
          </span>
        );
      },
    },
  ];

  return (
    <>
      {(selectedIds.length > 0 || showPayrollForm) && (
        <>
          {showPayrollForm ? (
            <PayroleProcessForm
              userInfoData={userInfoData}
              selectedIds={staffData.filter((emp) =>
                selectedIds.includes(emp.user_id)
              )}
              onClose={() => setShowPayrollForm(false)}
              callFunction={() => {
                setSelectedIds([]);
              }}
            />
          ) : (
            <div className="pp-selected-staff-info">
              <button
                type="button"
                className="pp-btn-process"
                onClick={() => setShowPayrollForm(true)}
              >
                {selectedIds.length} Staff Selected -{" "}
                <span>Click to generate payrole</span>
              </button>
            </div>
          )}
        </>
      )}

      <div className="pp-employee-payroll-table-wrapper mt30">
        {loading ? (
          <Loader />
        ) : (
          <PaymentLinkTable tableData={staffData} tableColumns={columns} />
        )}
      </div>
    </>
  );
};

export default NewPayroleProcess;
